export default __webpack_public_path__ + "e47d96756f290bf048fc0ac86f7851e2.png";